/**
 *
 * Asynchronously loads the component for BulkImportTemplate
 *
 */

import { lazyLoad } from 'utils/loadable';

export const BulkImportTemplate = lazyLoad(
  () => import('./index'),
  module => module.BulkImportTemplate,
);
